import { useTranslate } from '@tolgee/react';
import { DetailImg, LogisticsContent, LogisticsItem } from './styles';
import { Popover } from 'antd';
import { Trigger as PopoverTrigger } from './TradeRefund';
import detailSvg from 'views/Aide/assets/more.svg';
import { dateFormatter } from 'views/Refund/components/ReturnListItem/Logistics';
import { getLogisticsShipmentStatusLabel } from 'services/i18n/enum/order';

export interface ReverseLogisticsProps {
  sn: string;
  conversation: Conversation.Conversation;
  trade: Conversation.Trade.TradeWithLogistics;
  refundReason: Conversation.Trade.RefundReason;
  data: Conversation.Trade.ReturnProduct[];
  exportMode: boolean;
}

export const ReverseLogistics = (props: ReverseLogisticsProps) => {
  const {
    sn,
    trade: { reverseLogisticsList },
  } = props;

  const { t } = useTranslate();

  const current = reverseLogisticsList?.filter((_) => _.externalReturnId === sn);
  if (!current?.length) {
    return <></>;
  }

  const { leChatStatus, deliveryTimeMs, deliverySlaTimeMinMs, deliverySlaTimeMaxMs } = current[0];

  return (
    <div>
      <LogisticsItem>
        <span>{t('scene.chatWorkspace.orderTab.returnRefund.label.reverseLogistics')}</span>
        <div>
          {getLogisticsShipmentStatusLabel(t, leChatStatus)}
          <Popover
            trigger="click"
            arrowPointAtCenter
            placement="bottomRight"
            content={
              <LogisticsContent
                isReverse
                externalReturnId={sn}
                platform="SHOPEE"
                logisticsPackageList={reverseLogisticsList || []}
                reportTranslation={false}
              />
            }
          >
            <PopoverTrigger>
              <DetailImg src={detailSvg} alt="detail" />
            </PopoverTrigger>
          </Popover>
        </div>
      </LogisticsItem>
      {leChatStatus === 'LE_CHAT_SIGNED' ? (
        <div className="text-right text-[var(--fett-text-tertiary)] text-[12px]">
          {t('scene.chatWorkspace.orderTab.returnRefund.label.deliveredAt', {
            date: dateFormatter(deliveryTimeMs),
          })}
        </div>
      ) : Number(deliverySlaTimeMinMs) && Number(deliverySlaTimeMaxMs) ? (
        <div className="text-right text-[var(--fett-text-tertiary)] text-[12px]">
          {t('scene.chatWorkspace.orderTab.returnRefund.label.estimatedDelivery', {
            date1: dateFormatter(deliverySlaTimeMinMs),
            date2: dateFormatter(deliverySlaTimeMaxMs),
          })}
        </div>
      ) : null}
    </div>
  );
};
